import axios from "axios";
import { http } from "config/http";
import { http2013 } from "config/http2013";
import { http2020 } from "config/http2020";
import { http9006 } from "config/http9006";
export const http2024 = axios.create({
    baseURL: process.env.REACT_APP_COMPARE_IMAGE,
});

export const lensRecommendation = async (body: any) => {
    try {
        const res = await http2013.post(`ron_lens_recommendation`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const lensRecommendationRRU = async (body: any) => {
    try {
        const res = await http2020.post(`ron_lens_recommendation`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

type LensAPIType = {
    client_env: string | null,
    image_extension: string,
    user_name: string | null,
    image: string,
    system_prompt: string,
    input_image_id?: string,
    output_image_id?: string[],
    conversation_id: string,
    input_temp_path?: string,
    output_temp_path?: string[],
    notes?: string | undefined,
    tag?: string[],
    original_input_image_path?: string,
    size?: string,
    custom_width?: number,
    custom_height?: number,
    is_save: boolean
}

export const smartBackground = async (body: LensAPIType) => {
    try {
        const res = await http.post(`background_change`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const generateInstance = async (body: LensAPIType) => {
    try {
        const res = await http.post(`instance_change`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const imageExpansion = async (body: LensAPIType) => {
    try {
        const res = await http.post(`image_expansion`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

interface HistoryBody {
    source_name: string,
    user_name: string | null,
    client_env: string | null,
    tag_filter?: string[],
}
export const lensHistory = async (body: HistoryBody) => {
    try {
        const res = await http.post(`user_wise_lens_history`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const uniqueTags = async (sourceName: string,) => {
    try {
        const res = await http.post(`user_wise_unique_tags?source_name=${sourceName}&user_name=${localStorage.getItem("username")}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}
interface historyByConversationIdType {
    source_name: string,
    conversation_id: string | null,
    client_env: string | null,
    tag_filter?: string[],
}

export const historyImages = async (body: historyByConversationIdType) => {
    try {
        const res = await http.post(`get_lens_images_by_conversation`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const getImagebyID = async (sourceName: string, conversationId: string | null, inputImageId: string | null) => {
    try {
        const res = await http.get(`get_perticuler_image_data?source_name=${sourceName}&conversation_id=${conversationId}&client_env=${localStorage.getItem("clientName")}&input_image_id=${inputImageId}`)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const deleteImage = async (sourceName: string, inputImageId: string) => {
    try {
        const res = await http.get(`delete_image?source_name=${sourceName}&user_name=${localStorage.getItem("username")}&client_env=${localStorage.getItem("clientName")}&input_image_id=${inputImageId}`)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

type updateAndNotes = {
    client_env: string | null,
    source_name: string,
    input_image_id: string,
    tag: string[],
    note: string
}
export const updateTagAndNotes = async (body: updateAndNotes) => {
    try {
        const res = await http.post(`update_tag_and_notes`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

type deleteCoversationType = {
    client_env: string | null,
    user_name: string | null,
    conv_id: string | null,
    source_name: string | null,
}
export const deleteCoversation = async (body: deleteCoversationType) => {
    try {
        const res = await http9006.post(`delete_lens_temp_conversation`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

type suggestionImage = {
    client_env: string | null,
    image_extension: string,
    user_name: string | null,
    image: string
}
export const suggestionImages = async (body: suggestionImage) => {
    try {
        const res = await http.post(`image_suggestion`, body)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const compareImages = async (body: any) => {
    try {
        const res = await http2024.post(`Compare_Image_Grid`, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const similarityImages = async (body: any) => {
    try {
        const res = await http2024.post(`RONLens_MG`, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}